import React, { useState } from "react";
import {
  Card as MuiCard,
  Box,
  Typography,
  useTheme,
  useMediaQuery,
  Button
} from "@mui/material";

import Image from "../common/Image";
import { useTranslation } from "react-i18next";

const GameCard = ({
  imageUrl,
  imageHeight,
  imageWidth,
  onClick,
  title,
  subtitle,
  description,
  isHotGame,
  isFeatureGame,
  alt
}) => {
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down("sm"));
  const tabletView = useMediaQuery(theme.breakpoints.between("sm", "lg"));
  const ipadProView = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const [isHovered, setHover] = useState(false);
  const { t } = useTranslation();

  return (
    <MuiCard
      variant="outlined"
      sx={{
        cursor: "pointer",
        backgroundColor: "transparent",
        borderRadius: 3,
        border: 0,
        height: "auto",
        width: imageWidth,
      }}
      onClick={onClick}
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <Box
        overflow="hidden"
        sx={{ borderRadius: 3, textAlign: "center",position: "relative" }}
        height={ipadProView ? "120px" : imageHeight}
        width={ipadProView ? "120px" : imageWidth}
      >
         {isHotGame && (
          <Box
            component="img"
            src={"/assets/img/hotbanner.png"}
            alt="Featured Game"
            sx={{
              position: 'absolute',
              zIndex: 2,
              width:  { xs: '55px', sm: '65px', md: '60px', lg: '60px' },
              height: { xs: '55px', sm: '65px', md: '60px', lg: '60px' },
              top:  { xs: '-5px', sm: '-8px', md: '5px', lg: '0px' },
              left: { xs: '-5px', sm: '-8px', md: '20px', lg: '0px' },
            }}
          />
        )}
        
        <Image
          src={imageUrl}
          sx={{
            position: "relative",
            top: 0,
            opacity: isHovered ? "0.3": "1",
            // objectFit: "cover",
          }}
          hovered={true}
          alt={alt}
          height={ipadProView ? "120px" : imageHeight}
          width={ipadProView ? "120px" : imageWidth}
        />
        {isHovered && !mobileView && (
          <Button
            size="sm"
            style={{
              marginTop: "-170px",
              backgroundImage: "url(/assets/img/red_small.png)"
            }}
            variant="primary"
          >
            {t("home.playNow")}
          </Button>
      )}  
      </Box>

      {title && !mobileView && !tabletView && (
        <Box sx={{
            pt: 1,
            pb: 1, 
            pl: "13px",
            pr: "13px",
            width: "100%", 
        }}>
          <Typography
            color={process.env.REACT_APP_COLOR_TEXT || "white"}
            fontSize={12}
            textAlign="left"
            fontWeight={500}
          >
            {title}
          </Typography>
        </Box>
      )}

      {title && (mobileView || tabletView) && (
        <Box sx={{

          pl: "13px",
          pr: "13px",
          width: "100%", 
        }}>
          <Typography
            color={process.env.REACT_APP_COLOR_TEXT || "white"}
            fontSize={11}
            textAlign="left"
            fontWeight={500}
          >
            {title}
          </Typography>
          </Box>
      )}

      {/* subtitle to show game provider, commentted cause it seems unused */}
      {/* {title && subtitle && (
        <>
          {mobileView || tabletView && (
            <Box
              display="flex"
              flexDirection="column"
              p={1}
              justifyContent="center"
            >
              <Typography
                fontWeight={600}
                color={"white"}
                fontSize={7}
                textAlign="left"
              >
                {subtitle}
              </Typography>
            </Box>
          )}
        </>
      )} */}
    </MuiCard>
  );
};

export default GameCard;
